import { InputCostEstimationDialogState } from ".";

const fieldPath = {
  pjtBdgtAcqstnReqTypeCd: "costEstimation.pjtBdgtAcqstnReqTypeCd",
  statsOfAgreementOnBudgetaryTypeCd:
    "costEstimation.statsOfAgreementOnBudgetaryTypeCd",
};

export const InputCostEstimationDialogInitialState: InputCostEstimationDialogState =
  {
    isShow: false,
    saved: {},
    edited: {},
    codes: {
      pjtBdgtAcqstnReqType: [],
      statsOfAgreementOnBudgetaryType: [],
    },
    fieldPath: fieldPath,
    pjtId: "",
    updateDateTime: "",
    status: {
      invalidList: [],
      isSaved: false,
    },
  };
